export const visit = (vm, at) => {
vm(require("foundations-components/lang/da.lyaml"));
at({ "da": { "placeholder": "pladsholder" } });
};